import { useState } from 'react';
import { useLang } from 'hooks/lang';

import { ProjectTag } from 'entities';

import { Button, Column, Row } from 'components/Blocks';
import { ButtonGroup } from 'components/ButtonGroup';
import { CardsIcon, PlusIcon, TableIcon } from 'components/Icons';

import { ProjectTagForm } from './Form';
import { ProjectTagCards } from './TagCards';
import { ProjectTagsTable } from './TagsTable';

import { generateRandomHexColor } from 'utils/color';

import { useTeamProfile } from '../context';
import { appStorage } from 'utils/storage';

const viewKey = 'team_tag_view';

const getDefaultTag = (): ProjectTag => ({
  name: '',
  color: generateRandomHexColor(),
});

export function TeamProjectTags() {
  const { t } = useLang();
  const { canMutateEntities } = useTeamProfile();

  const [focusedTag, setFocusedTag] = useState<ProjectTag | null>(null);

  const [view, setView] = useState(() => appStorage.session.get(viewKey) ?? 'cards');

  const changeView = (view: string) => {
    setView(view);
    appStorage.session.set(viewKey, view);
  };

  return (
    <Column>
      <Row>
        <h6>{t('project-tags')}</h6>

        <div className="ml-auto">
          <ButtonGroup
            value={view}
            onChange={changeView}
            options={[
              { label: <CardsIcon />, value: 'cards' },
              { label: <TableIcon />, value: 'table' },
            ]}
          />
        </div>

        {canMutateEntities && (
          <Button
            format="square"
            round
            onClick={() => setFocusedTag((old) => (old ? null : getDefaultTag()))}
          >
            <PlusIcon />
          </Button>
        )}
      </Row>

      <ProjectTagForm close={() => setFocusedTag(null)} projectTag={focusedTag} />

      {view === 'table' ? (
        <ProjectTagsTable setFocusedTag={setFocusedTag} />
      ) : (
        <ProjectTagCards setFocusedTag={setFocusedTag} />
      )}
    </Column>
  );
}
